import { LocaleStartParams } from '@platform-frontend/transloco';

export interface AccountStartParams<T extends LocaleStartParams = LocaleStartParams> {
  redirect?: string;
  appStartParams?: T;
}
